import { request } from '@tencent/ppd-base-libs';

/**
 *  查询CDK可以兑换的奖品Id
 * @param cdk  用户填入的cdkey
 * @param ticket 防水墙返回的票据
 * @param randstr 防水墙返回的随机码
 * @returns
 */
export async function queryGoodsId(cdk: string, ticket: string, randstr: string) {
  const url = '/app/promotion/cdkey/cdkey_qry_prize.cgi';
  const res = await request.get(url, { params: { cdk, ticket, randstr } });
  const list: Record<string, string>[] = res.prize_info_list;
  const [prizeId] = list.map(item => item.prize_id);
  return prizeId;
}

export async function getGoodsInfo(prizeId: string) {
  const url = '/app/promotion/prom_show_goods_info.cgi';
  const res = await request.get(url, { params: { goods_type: 'coupon', goods_id_list: prizeId } });
  const list: Record<string, string>[] = res.goods_arr;
  return list[0];
}

/**
 * CDK兑换
 * @param cdk cdk
 * @param ticket 防水墙ticket
 * @param prizeId 兑换奖品ID
 */
export async function requestExchangeCDK(cdk: string, ticket: string, prizeId: string) {
  const url = '/app/promotion/cdkey/cdkey_exch.cgi';
  await request.get(url, { params: { cdk, ticket, prize_id: prizeId } });
  return true;
}


